import React from 'react';
import { useTypingContext, useChannelStateContext, useChatContext } from 'stream-chat-react';
import '../styles/CustomTypingIndicator.css';
/**
 * CustomTypingIndicator component for both channel and thread typing.
 * @param {object} props - TypingIndicatorProps from stream-chat-react.
 * @returns {JSX.Element|null}
 */
const CustomTypingIndicator = (props) => {
  const { threadList } = props || {};
  const { channelConfig, thread } = useChannelStateContext();
  const { client } = useChatContext();
  const { typing = {} } = useTypingContext();

  if (channelConfig?.typing_events === false) {
    return null;
  }

  // Users typing in the main channel (not in a thread)
  const typingInChannel = !threadList
    ? Object.values(typing).filter(
        ({ parent_id, user }) => user?.id !== client.user?.id && !parent_id
      )
    : [];

  // Users typing in the current thread
  const typingInThread = threadList
    ? Object.values(typing).filter(
        ({ parent_id, user }) =>
          user?.id !== client.user?.id && parent_id === thread?.id
      )
    : [];

  const typingUsers = threadList ? typingInThread : typingInChannel;

  if (typingUsers.length === 0) return null;

  return (
    <div
      className={`str-chat__typing-indicator ${
        typingUsers.length ? 'str-chat__typing-indicator--typing' : ''
      }`}
    >
      <div className="str-chat__typing-indicator__avatars">
        {typingUsers.map(({ user }, i) => (
          <div className="username" key={user?.id || i}>
             <div className="typing-indicator-name">{user?.name} is typing</div> 
          </div>
        ))}
      </div>
      <div className="str-chat__typing-indicator__dots">
        <div className="str-chat__typing-indicator__dot" />
        <div className="str-chat__typing-indicator__dot" />
        <div className="str-chat__typing-indicator__dot" />
      </div>
    </div>
  );
};

export default CustomTypingIndicator;
